module.exports = __webpack_public_path__ + "img/talentBg.2d60a8bd.png";